<template>
	<div class="OrderAbnormal " >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-orderManage Icon"></i>
			<span class="header_text">/ 项目任务 / 异常订单</span>
		</div>
		<div class="content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<template class="">
				<el-table :data="orderList" stripe style="width: 100%">
					<el-table-column prop="order_sn" label="订单编号" width="240px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.order_sn}}</span>
						</template>
					</el-table-column>
					<el-table-column label="接单人" width="120px">
						<template slot-scope="{row,$index}">
							<span @click="gotToDetail(row)" class="cursor-pointer font-underline ">{{row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="project_name" label="项目名称" min-width='150px' :show-overflow-tooltip="true"></el-table-column>
					<el-table-column align="right" label="任务金额" width="100px">
						<template slot-scope="{row,$index}">
							<span class="font-consolas">{{row.money  | filterNumber}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="status"  align="center" label="状态" width="120px">
						<template slot-scope="{row,$index}">
							<span class="dd-state-0" v-if="row.status=='0'" >打款失败</span>
						</template>
					</el-table-column>
					<el-table-column label="银行卡号" width="170px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.bank_card | sub_blank}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bank_card" label="银行名称" width="170px">
						<template slot-scope="{row,$index}">
							<span>{{row.bank_name}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" label="接单时间" width="150px">
						<template slot-scope="{row,$index}">
							<span class="font-Tahoma">{{row.addtime}}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="addtime" label="异常原因" :show-overflow-tooltip="true"></el-table-column> -->
					<el-table-column fixed="right" label="操作" width="80px">
						<template slot-scope="{row,$index}">
							<el-link class="InfoFont" type="primary" @click="gotToDetail(row)">详情</el-link>
							<!-- <el-link class="InfoFont" type="success" @click="retry(row)">重发</el-link> -->
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</template>
		</div>
		<!-- 有错误人员提示 -->
		<el-dialog title="异常订单重发" :visible.sync="retryShow" width="40%"  :close-on-click-modal="false">
			<div>
				<div class="contentDetailBox onebox">
					<div class="row_box ">
						<div class="fl"><span>接单人：</span></div>
						<div class="fl"><span>{{retryDate.name}}</span></div>
					</div>
					<div class="row_box ">
						<div class="fl"><span>任务金额：</span></div>
						<div class="fl"><span class="font-consolas">{{retryDate.money}}</span></div>
					</div>
					<div class="row_box ">
						<div class="fl"><span>身份证号：</span></div>
						<div class="fl"><span class="font-Tahoma"></span></div>
					</div>
					<div class="row_box ">
						<div class="fl"><span>开户行：</span></div>
						<div class="fl"><span>
							<el-input placeholder="" v-model="retryDate.bank_name" ></el-input>
						</span></div>
					</div>
					<div class="row_box ">
						<div class="fl"><span>银行卡号码：</span></div>
						<el-input placeholder="" v-model="retryDate.bank_card" ></el-input>
					</div>
				
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<span class="btnOK" >确认发放</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'OrderAbnormal',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				orderList:[],
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100], //每页展示条数
				pageSizeNow: 20, //当前每页多少行
				id:'',
				searchPrice:'',//搜索值
				retryShow:false,  //重发弹框
				retryDate:{}, //重发数据
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //判断是否登录
					window.location = 'login.html';
					return;
				}
				this.id = this.$route.query.id;
				if(this.id == undefined){
					this.id = '';
				}
				this.getOrderList();
			},
			// 获取错误数据
			getOrderList(){
				let fn = new FormData();
				fn.append('id', this.id); //文件
				fn.append('page', this.pageNum); //页码
				fn.append('page_size', this.pageSizeNow); //条数
				this.$http.post(this.url + '/zhongfy/company/ErrorOrder', fn).then((res) => {
					if (res.data.code == '200' || res.data.msg == '成功') {
						console.log(res.data.data);
						if(res.data.data !=undefined){
							this.orderList = res.data.data.list;
							this.total = res.data.data.count;
						}
						
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else{
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误');
				})
			},
			gotToDetail(row){ //去详情
				this.$router.push({
					path:'/orderDetail',
					query:{
						id : row.id
					}
				})
			},
			retry(row){ //重发
				this.retryDate = row;
				this.retryShow = true;
			},
			handleCurrentChange(val) { //切换页数
				this.pageNum = val;
				this.getOrderList();
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1;
				this.getOrderList();
			},
		},
		filters:{
			
		}
	}
</script>

<style scoped>
	.contentDetailBox .row_box {
		min-height: 50px;
	}
	.contentDetailBox .row_box>div:nth-child(1) {
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: right;
		color: #666666;
		font-size: 14px;
	}
	
	.contentDetailBox .row_box>div:nth-child(2) {
		padding-left: 10px;
		height: 30px;
		line-height: 30px;
		color: var(--theme-black);
		font-size: 16px;
		width: 60%;
	}
	
	
	
	
</style>



// WEBPACK FOOTER //
// src/components/OrderAbnormal.vue